import React, { useEffect, useMemo, useState } from 'react'
import { decorationMobx, eatTypeStatusMobx } from '@mobxStore'
import { showMsg } from '@utils'
import { cartMobx } from 'restaurant'
import './style.scss'
import { classNames } from '@dt/fe-utils'
import CashierController from '@ctrls/cashierController'
import { observer } from 'mobx-react'
import { Icon } from '@cps'

export interface IEatTypeSwitcherProps {
}

const EatTypeSwitcher: React.FC<IEatTypeSwitcherProps> = (props) => {
  const [showMore, setShowMore] = useState<boolean>(false)
  const { eatTypeEntries, eatTypeEntriesMap } = decorationMobx
  const eatType = cartMobx.info.eatType

  const types = useMemo(() => {
    const arr: TEatType[] = eatTypeEntries.map(item => item.value)
    return arr || [eatType]
  }, [eatTypeEntries])

  const handleSwitch = (val: string) => {
    setShowMore(false)
    if (eatTypeStatusMobx.disableSwitchEatType) {
      showMsg(i18n.t('menu.disableSwitchEatType'))
      return
    }
    if (val !== eatType) {
      CashierController.switchEatType(val as TEatType)
    }
  }

  const handleMoreEatType = () => {
    setShowMore(true)
  }

  /** 单个就餐方式 */
  const OneEatType = () => {
    const item = types?.[0] || eatType
    return (
      <div className='eat-type-item active'>
        <span className='txt'>{eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</span>
      </div>
    )
  }

  /** 两个就餐方式,来回切换 */
  const TwoEatType = () => {
    const nextItem = types.find((item) => item !== eatType) || null
    return (
      <div className='eat-type-wrap'>
        {types.map((item, index) => (
          <div
            key={item}
            className={classNames('eat-type-item', { active: eatType === item, left: index === 0, right: index === 1 })}
            onClick={() => handleSwitch(nextItem || item)}
          >
            <span className='txt'>{eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</span>
          </div>
        ))}
      </div>
    )
  }

  /** 两个以上就餐方式，切换需要浮窗 */
  const TwoEatTypeMore = () => {
    const item: string = eatType
    return (
      <div className='eat-type-wrap'>
        <div className='eat-type-item left active' onClick={() => handleMoreEatType()}>
          <span className='txt'>{eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</span>
        </div>
        <div className='eat-type-item right'>
          <span className='txt'><Icon name='shenglvehao' /></span>
        </div>
      </div>
    )
  }

  const MoreEatTypeModal = () => {
    return (
      <div className={classNames('eat-type-wrap-modal', { show: showMore })}>
        {types.map((item) => (
          <div key={item} className='eat-type-modal-item' onClick={() => handleSwitch(item)}>
            <span>{eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</span>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='eat-type-bar'>
      {
        types.length === 2 ? (
          <TwoEatType />
        ) : types.length >= 3 ? (
          <TwoEatTypeMore />
        ) : <OneEatType />
      }
      <MoreEatTypeModal />
    </div>
  )
}

export default observer(EatTypeSwitcher)
